"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TextInputHelperCurrency = void 0;
var honeycomb_1 = require("@honeycomb-npm/honeycomb");
var PropTypes = require("prop-types");
var React = require("react");
var TextInputHelper_1 = require("./TextInputHelper");
/* tslint:disable:no-string-literal */
var TextInputHelperCurrency = function (props) {
    var min = props.min, max = props.max, precision = props.precision, attributes = __rest(props, ["min", "max", "precision"]) // tslint:disable-line
    ;
    attributes['parser'] = function (value) {
        return honeycomb_1.Parsers.parseNumber(value, precision);
    };
    attributes['formatter'] = function (value) {
        return honeycomb_1.Formatters.formatCurrency(value);
    };
    var validators = [];
    if (props.required) {
        validators.push({
            errormessage: 'Enter an amount.',
            method: function (value) {
                return honeycomb_1.Validators.minLength(value, 1);
            },
        });
    }
    if (typeof props.min !== 'undefined') {
        var errormessage = "That's less than the minimum amount of " + honeycomb_1.Formatters.formatCurrency(min) + ". Enter a higher amount.";
        validators.push({
            errormessage: errormessage,
            method: function (value) {
                if (value === '' && props.required === false) {
                    return true;
                }
                return honeycomb_1.Validators.minValue(value, min);
            },
        });
    }
    if (typeof props.max !== 'undefined') {
        var errormessage = "That's more than the maximum amount of " + honeycomb_1.Formatters.formatCurrency(max) + ". Enter a lower amount.";
        validators.push({
            errormessage: errormessage,
            method: function (value) {
                if (value === '' && props.required === false) {
                    return true;
                }
                return honeycomb_1.Validators.maxValue(value, max);
            },
        });
    }
    if (validators.length > 0) {
        attributes['validators'] = validators;
    }
    return (React.createElement(TextInputHelper_1.TextInputHelper, __assign({}, attributes)));
};
exports.TextInputHelperCurrency = TextInputHelperCurrency;
exports.TextInputHelperCurrency['defaultProps'] = {
    required: false,
};
exports.TextInputHelperCurrency['propTypes'] = {
    helptext: PropTypes.string,
    id: PropTypes.string.isRequired,
    label: PropTypes.string.isRequired,
    max: PropTypes.number,
    min: PropTypes.number,
    name: PropTypes.string,
    onChange: PropTypes.func,
    precision: PropTypes.number,
    required: PropTypes.bool,
    value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};
/* tslint:enable:no-string-literal */
